function o(t = 8) {
  return Math.random().toString(16).slice(2, 2 + t);
}
function c(t, n) {
  const r = [];
  for (let e = 0; e < t; ++e)
    r.push(n);
  return r;
}
export {
  o as createId,
  c as repeat
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/seemly@0.3.10/~/seemly/es/misc/index.js
// module id = 103
// module chunks = 41